import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * <product-baleni-component>
 *
 * Zobrazuje řádek "Balení: …" pod variant pickerem na PDP. Při změně varianty se
 * hodnota aktualizuje z re-renderovaného HTML, které nese VariantUpdateEvent
 * (event.detail.data.html) — stejný vzor, jakým theme aktualizuje cenu v
 * product-form.js. Server vykreslí správnou hodnotu pro každou variantu, JS jen
 * promorphuje hodnotu při výběru.
 */
class ProductBaleniComponent extends HTMLElement {
  #onVariantUpdate = (event) => {
    const detail = event.detail;
    if (!detail || !detail.data || !detail.data.html) return;

    // Kombinované listingy / více produktových formulářů: reaguj jen na svůj produkt.
    const productId = this.dataset.productId;
    if (detail.data.productId && productId && detail.data.productId !== productId) return;

    const nextComponent = detail.data.html.querySelector(
      `product-baleni-component[data-product-id="${productId}"]`
    );
    const currentValue = this.querySelector('.product-baleni__value');
    const nextValue = nextComponent?.querySelector('.product-baleni__value');

    if (currentValue && nextValue) {
      morph(currentValue, nextValue);
    } else if (currentValue) {
      // Nová varianta nemá velikost balení → vyprázdni hodnotu.
      currentValue.textContent = '';
    }

    // Počet dávek (inline za velikostí balení) — stejný morph vzor jako hodnota výše.
    const currentDavky = this.querySelector('.product-baleni__davky');
    const nextDavky = nextComponent?.querySelector('.product-baleni__davky');

    if (currentDavky && nextDavky) {
      morph(currentDavky, nextDavky);
    } else if (currentDavky) {
      currentDavky.textContent = '';
    }
  };

  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }
}

if (!customElements.get('product-baleni-component')) {
  customElements.define('product-baleni-component', ProductBaleniComponent);
}
